import HasId from '@/data/models/base/HasId';

/**
 * BaseModel
 */
export default class BaseModel implements HasId {
  public id: string;

  public setId(id: string): void {
    this.id = id;
  }

  public getId(): string {
    return this.id;
  }

}
